export function show(el: HTMLElement): void {
    if (el && el.style.display === "none") {
        const display = el.dataset["displayAs"] ?? "block";
        el.style.display = display;
    }
}

export function hide(el: HTMLElement): void {
    if (el && el.style.display !== "none") {
        el.dataset["displayAs"] = el.style.display;
        el.style.display = "none";
    }
}

export function setOrHide(el: HTMLElement, text: string) {
    if (text && text.length > 0) {
        show(el);
        el.innerText = text;
    } else {
        hide(el);
    }
}

export function setOrHideImg(el: HTMLImageElement, url: string) {
    if (url && url.length > 0) {
        show(el);
        el.src = url;
    } else {
        hide(el);
    }
}